// extracted by mini-css-extract-plugin
export default {"rating":"Rating_rating__a2PAc","count":"Rating_count__kMOcm","votes":"Rating_votes__PnmhT"};